import {
	Alert,
	Box,
	Button,
	FormControl,
	Icon,
	FormHelperText,
	InputLabel,
	OutlinedInput,
	Paper,
	Link,
	Snackbar,
	Stack,
	Typography,
	CircularProgress,
	useTheme,
	TextField,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState, useRef, createRef } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Code from "./textFieldCode";
import Interval from "./contador";
import ReCAPTCHA from "react-google-recaptcha";
import styled from "styled-components";
import LoaderThreeDots from "../../components/loadingAnimation";
import { color } from "@mui/system";

export default function SolicitarRedefinirSenha() {
	const [rev, setRev] = useState(false);
	const [email, setEmail] = useState("");
	const [Null, setNull] = useState(false);
	const [alertOpen, setAlertOpen] = useState(false);
	const [alertServiceOpen, setAlertServiceOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [captcha, setCaptcha] = useState(false);
	const [sended, setSended] = useState(false);
	const [user, setUser] = useState("");
	const [code, setCode] = useState("");
	const [codeAlert, setCodeAlert] = useState(false);
	const [id, setId] = useState("");
	const [emailValid, setEmailValid] = useState(false);
	const intervalRef = useRef(null);
	const recaptchaRef = createRef();
	const theme = useTheme();
	const url = `${
		window?.config?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL || ""
	}`;
	const navigate = useNavigate();

	const styles = {
		LoadingLogo: {
			// m: 1,
			position: "relative",

			margin: "50px",
		},
		CircularProgress: {
			color: "primary",
			position: "absolute",
			top: -9,
			left: -6,
			zIndex: 1,
		},
		TextCampo: {
			mt: 1,
			mb: 2,
			width: "200px",
		},
	};

	useEffect(() => {
		if (email.includes("@") && email.includes(".")) setEmailValid(true);
		else setEmailValid(false);
	}, [email]);

	useEffect(() => {
		setCaptcha(null);
	}, []);

	const handleNextUpdatePassword = async () => {
		try {
			const response = await axios.post(
				`${url}/usuario/resetPassword/validate`,
				{
					code,
					usuarioId: id,
				},
			);

			navigate(`/redefinirSenha/${response.data.token}/${id}`);
		} catch (error) {
			if (error?.response?.status == 401) {
				setCodeAlert(true);
			} else {
				setAlertServiceOpen(true);
			}
		}
	};

	const handleSend = async () => {
		if (!email || !emailValid) {
			setNull(true);
			return;
		}
		setLoading(true);
		try {
			const response = await axios.post(
				`${url}/usuario/resetPassword/request`,
				{
					email: email.toLowerCase(),
				},
			);
			setUser(response.data.login);
			setId(response.data.usuarioId);

			setSended(true);
		} catch (error) {
			console.log(error);
			if (error?.response?.status == 404) {
				setAlertOpen(true);
			} else {
				setAlertServiceOpen(true);
			}
		}
		setLoading(false);
	};
	function handleStartCounter() {
		if (intervalRef.current) {
			intervalRef.current.startCounter();
		}
	}

	return (
		<>
			<Box
				sx={{
					zIndex: -1,
					height: "100vh",
					width: "98vw",
					position: "absolute",
					top: 0,
				}}
			/>

			<Paper
				sx={{
					minWidth: "350px",
					maxWidth: "95vw",
					padding: "20px 50px",
					width: { xs: "95vw", sm: "650px" },
					margin: "auto",
					borderRadius: "20px",
					marginTop: "5vh",
					alignItems: "center",
					justifyContent: "center",
					flexDirection: "column",
					display: "flex",
					bgcolor: theme.palette.background.paper,
				}}
			>
				<Stack
					direction={"column"}
					gap={"15px"}
					alignItems={"center"}
					sx={{ padding: "0px", width: "100%", mt: 2 }}
				>
					<Typography
						sx={{
							textAlign: "center",
							fontSize: "26px",
							fontWeight: 400,
						}}
					>
						Redefinição de senha
					</Typography>
					{loading && (
						<Box sx={styles.LoadingLogo}>
							<LoaderThreeDots />
						</Box>
					)}
					{!loading && !sended && (
						<>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
								<Typography sx={{ color: theme.palette.paletteCharts.disable }}>
									Informe o e-mail cadastrado para redefinir sua senha
								</Typography>
							</Box>

							<TextField
								sx={{ m: 1, width: "100%", marginTop: "0px" }}
								variant="filled"
								label="Email"
								type="email"
								id="emailredefine"
								value={email}
								onChange={(event) => {
									setEmail(event.target.value);
								}}
								error={Null && !emailValid}
								helperText={Null && !emailValid ? "Email inválido" : ""}
							/>

							{/* <ReCAPTCHA
								id="recaptcha"
								key={"recaptcha"}
								size={"normal"}
								sitekey={
									window?.config?.REACT_APP_RECAPTCHA ||
									process.env.REACT_APP_RECAPTCHA ||
									""
								}
								onChange={setCaptcha}
							/> */}

							<Button
								variant="contained"
								//disabled={!captcha}
								onClick={() => {
									handleSend();
								}}
								sx={{
									width: "90%",
									borderRadius: "5px",
									marginTop: "10px",
									height: "40px",
									marginBottom: "20px",
									bgcolor: theme.palette.secondary.main,
									color: theme.palette.white.main,
									"&:hover": {
										bgcolor: theme.palette.secondary.dark,
									},
								}}
							>
								Recuperar senha
							</Button>
						</>
					)}
					{!loading && sended && (
						<>
							<Typography
								sx={{
									fontSize: "1.1em",
									textAlign: "center",
									mb: "20px",
									color:
										theme.palette.mode === "dark"
											? theme.palette.paletteCharts.disable
											: theme.palette.colors.gray.darker,
								}}
							>
								<br />
								Enviamos um email com um código para{" "}
								<span
									style={{
										color: theme.palette.secondary.main,
										fontWeight: 500,
									}}
								>
									{" "}
									{email.toLowerCase()}
								</span>
								, acesse e escreva-o abaixo:
								<br />
							</Typography>

							<Code onChange={(value) => setCode(value.join(" "))} />
							{codeAlert && (
								<Typography
									sx={{
										fontSize: "13px",
										marginTop: "-10px",
										color: theme.palette.chip.colorText.critical,
										marginBottom: "-20px",
									}}
								>
									O código não está correto
								</Typography>
							)}

							<Button
								variant="contained"
								//		disabled={!captcha}
								onClick={handleNextUpdatePassword}
								sx={{
									width: "50%",
									borderRadius: "5px",
									marginTop: "20px",
									height: "40px",
									marginBottom: "20px",
									color: theme.palette.white.main,
									bgcolor: theme.palette.secondary.main,
									"&:hover": {
										bgcolor: theme.palette.secondary.dark,
									},
								}}
							>
								Verificar
							</Button>

							<Interval onTimeout={(value) => setRev(true)} ref={intervalRef} />
							{rev && (
								<Link
									onClick={() => {
										handleSend();
										handleStartCounter();
										setRev(false);
									}}
									href="#"
									sx={{
										width: "100%",
										textDecoration: "none!important",
										marginBottom: "20px",
										textAlign: "center",
									}}
								>
									Reenviar email de redefinição
								</Link>
							)}
						</>
					)}
				</Stack>
			</Paper>

			<Snackbar
				autoHideDuration={6000}
				open={alertOpen}
				onClose={() => {
					setAlertOpen(false);
				}}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert severity="error">Erro: Esse email não está cadastrado</Alert>
			</Snackbar>

			<Snackbar
				autoHideDuration={6000}
				open={alertServiceOpen}
				onClose={() => {
					setAlertServiceOpen(false);
				}}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert severity="error">
					Erro: Não foi possível se conectar ao Servidor
				</Alert>
			</Snackbar>
		</>
	);
}
